import { render, staticRenderFns } from "./LabSynthesisOfAlum.vue?vue&type=template&id=423a4331&"
import script from "./LabSynthesisOfAlum.vue?vue&type=script&lang=ts&"
export * from "./LabSynthesisOfAlum.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports